import * as React from "react";
import type { SVGProps } from "react";
const SvgDateIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="date_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M810.667 170.667h-85.334V128A42.667 42.667 0 0 0 640 128v42.667H384V128a42.667 42.667 0 0 0-85.333 0v42.667h-85.334a128 128 0 0 0-128 128v512a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128v-512a128 128 0 0 0-128-128zm42.666 640a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V512h682.666v298.667zm0-384H170.667v-128A42.667 42.667 0 0 1 213.333 256h85.334v42.667a42.667 42.667 0 0 0 85.333 0V256h256v42.667a42.667 42.667 0 0 0 85.333 0V256h85.334a42.667 42.667 0 0 1 42.666 42.667v128z"
    />
  </svg>
);
export default SvgDateIcon;
